export const GET_SR = 'GET_SR';

// Get SR (via saga)
export const getSR = (regions = []) => {
	return {
		type: 'GET_SR',
		options: {
			regions
		}
	}
}

// Put SR (from saga)
export const putSR = (sr = [], region = '') => {

	// console.log(sr);
	return {
		type: 'PUT_SR',
		payload: {
			sr,
			region
		}
	}
}

// Clear SR
export const clearSR = (sr = []) => {
	return {
		type: 'CLEAR_SR',
		payload: {
			sr,
		}
	}
}



// WEBPACK FOOTER //
// ./src/actions/sr.js